import { motion } from "framer-motion";
import { BookOpen } from "lucide-react";
import { coursework } from "@/data/portfolio";

export const Coursework = () => (
  <div className="relative mx-auto mt-24 max-w-7xl px-4 sm:px-8 lg:px-16" data-testid="coursework-block">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="flex items-center gap-3"
    >
      <BookOpen size={14} className="text-cyan-400" />
      <span className="font-mono text-xs uppercase tracking-[0.35em] text-cyan-400">Coursework · EPFL transcript</span>
    </motion.div>

    <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
      {coursework.map((deg, di) => (
        <motion.div
          key={deg.degree}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: di * 0.12, ease: [0.16, 1, 0.3, 1] }}
          className="card-glass rounded-xl border border-white/10 p-6 sm:p-8"
          data-testid={`coursework-degree-${di}`}
        >
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <h3 className="font-display text-lg font-bold text-slate-50">{deg.degree}</h3>
            <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
              {deg.school} · {deg.period}
            </span>
          </div>

          <div className="mt-6 space-y-6">
            {deg.groups.map((g) => (
              <div key={g.label}>
                <div className="flex items-center gap-3">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-violet-400">{g.label}</span>
                  <span className="h-px flex-1 bg-gradient-to-r from-violet-500/40 to-transparent" />
                </div>
                <ul className="mt-3 flex flex-wrap gap-2">
                  {g.courses.map((c) => (
                    <li
                      key={c}
                      className="rounded-md border border-white/10 bg-white/[0.02] px-3 py-1.5 font-mono text-[11px] text-slate-300 transition-all duration-300 hover:-translate-y-0.5 hover:border-cyan-400/50 hover:text-cyan-200 hover:glow-cyan"
                      data-testid={`course-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    >
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </motion.div>
      ))}
    </div>
  </div>
);
